// event ของสถานะโต๊ะ (ล็อค / แขก / หมายเหตุ / channel / ส่วนลด ...) — RTDB stores/{storeId}/tableStatesEvents/{id}
// ทุกเครื่อง POS append แล้ว reduce เป็น posStore.tableState / jobsStore.tablesInfo เอง
// แผนเต็ม: plans/03-table-state-events.md

export enum TableStateEventType {
  LOCK = "LOCK", // reason: MANUAL | PRINT_PREVIEW | PRINT_PREVIEW_MOBILE
  UNLOCK = "UNLOCK",
  SET_GUESTS = "SET_GUESTS", // payload.guests
  CLEAR_GUESTS = "CLEAR_GUESTS",
  SET_NOTE = "SET_NOTE", // payload.note
  CLEAR_NOTE = "CLEAR_NOTE",
  SET_CHANNEL = "SET_CHANNEL", // payload.channel — sc ของ channel ตามมาในตัว (แทน setServiceChange)
  CLEAR_CHANNEL = "CLEAR_CHANNEL", // ล้าง sc ของ channel ไปด้วย (แทน clearServiceChange)
  // หลาย field ใน event เดียว: payload.guests / payload.note / payload.channel — มีตัวไหนตั้งตัวนั้น ไม่มี = ไม่เปลี่ยน
  // เปิดโต๊ะใหม่จากตะกร้า / terminal: แขก + channel เป็น event เดียว แทน SET_GUESTS + SET_CHANNEL
  PATCH = "PATCH",
  SET_OPTION = "SET_OPTION", // payload.key + payload.value — ค่าที่ตั้งเองจาก TableOptions (ใช้คิดเงิน)
  RESET_OPTION = "RESET_OPTION", // payload.key — กลับไปใช้ค่าร้าน
  CLEAR = "CLEAR", // จ่ายเงินจนโต๊ะว่าง: event ก่อนหน้าของโต๊ะนี้ไม่มีผลทั้งหมด
  OPEN_SHOP = "OPEN_SHOP", // ตอนเปิดร้าน ไม่มี table — node ไม่ว่าง + บอกว่าโหลดชุดแรกครบ + รอบปัจจุบัน
}

export type TableOptionKey = "sc" | "dc2" | "cc" | "tax";

/** [mode, value] — mode 0 = % / 1 = บาท (tax: 1 = รวมในราคา / 2 = บวกเพิ่ม) */
export type TableOptionValue = [number, number];

export type TableOptions = Partial<Record<TableOptionKey, TableOptionValue>>;

/** shape เดิมของ tableState/{table} — posStore.tableState และ projection ที่มือถืออ่าน */
export interface TableStateValue {
  lock?: boolean;
  guests?: number;
  note?: string;
  channel?: Record<string, any>;
  sc?: TableOptionValue;
  dc2?: TableOptionValue;
  cc?: TableOptionValue;
  tax?: TableOptionValue;
}

export interface TableStateEvent {
  v: 1;
  /** = key บน RTDB: `{ts}_{computerUuid}_{rand}` */
  id: string;
  /** ทุก type ยกเว้น OPEN_SHOP */
  table?: string;
  type: TableStateEventType;
  /** epoch ms (server time) — ใช้เรียงก่อน reduce และเช็คอายุ 24 ชม. ของ outbox */
  ts: number;
  /** jobId ของ OPEN รอบนี้ — event ของรอบอื่นไม่มีผล */
  openJobId: string | null;
  payload?: {
    guests?: number;
    note?: string;
    channel?: Record<string, any>;
    key?: TableOptionKey;
    value?: TableOptionValue;
  };
  reason?: string;
  /** CLEAR จากการจ่ายเงิน = jobId ของ PAY job */
  ref?: string;
  by: {
    computerUuid: string | null;
    runMode: string | null;
    employeeId?: string;
    employeeName?: string;
  };
}
